import {
  PICKUP,
  ROUTES_INFO,
  DROP,
  DROPS,
  BOOKING_DISTANCE,
  BOOKING_DURATION,
  CAR_TYPE,
  SELECTED_LOCATION,
  AVAILABLE_CARS,
  BOOKING_SAVE,
  BOOKING_SCREEN_SIZE,
  BOOKING_DRIVER,
  ESTIMATED_PRICES,
  CHECK_ZONE,
  CURRENT_RIDE_CHECK,
  CANCEL_REASONS,
  BOOKING_CANCEL,
  START_TRIP,
  STOP_TRIP,
  PAYMENT_CONFIRM_TRIP,
  CHAT_MESSAGE_SEND,
  CHAT_MESSAGE_UPDATE,
  CHAT_OPEN_STATUS,
  SELECT_RIDE,
  NEW_CURRENT_RIDE,
  CLEAR_BOOKING,
  BOOKING_DATA_UPDATE,
  RATING_SAVE,
  LATEST_RIDES,
  CAR_EST_AMOUNT,
  BOOKING_PAYMENT_TYPE,
  BOOKING_AMOUNTS,
  ZONE_PAY_GATEWAYS,
  PAYMENT_LIST_DESC,
  REFRESH_BOOKING,
  CAR_LIST,
  GUEST_SAVE,
  FETCH_CANNED_REPLIES,
  SET_DRIVER_LIVE_LOCATION,
  SET_DRIVER_TRAIL,
  SET_DRIVER_ETA,
  SET_PAYMENT_CONFIRMATION,
  SET_PAYMENT_CONFIRMATION_SEND,
  APPLY_TIP,
  ISSUE_SHARE_LINK,
  FETCH_RECENT_RIDES,
  FETCH_EXTRA_CHARGES,
  DECIDE_EXTRA_CHARGE,
  FETCH_AMENDMENTS,
  REQUEST_AMENDMENT,
  FETCH_ADVANCES,
  DECIDE_ADVANCE,
  SET_BREAKDOWN_LINK,
  AIRPORT_SERVICE,
  FLIGHT_NUMBER,
  FLIGHT_DATETIME,
  TERMINAL,
  TRUNK_LUGGAGE,
  HAND_LUGGAGE,
} from "App/store/constants";
const initialState = {
  currentRidesList: null as any,
  bookingId: null,
  pickup: null,
  routesInfo: null,
  drop: [],
  drops: [],
  distance: null,
  duration: null,
  carType: null,
  driver: null as any,
  rider: null as any,
  otp: null,
  chat: [],
  chatMessageSend: null,
  isChatOpen: false,
  bookingSchedule: null,
  bookingTime: null,
  bookingStatus: null,
  scheduleId: null as number | null,
  scheduleUniCode: null as string | null,
  bookingAmounts: null,
  selectedLocation: null as any,
  bookingScreenSize: [1, 200],
  estimatedTime: null,
  estimatedDistance: null,
  estimatedPrices: null,
  availableCars: null,
  cancelReasons: null,
  tripStartTime: null,
  tripTime: null,
  tripDistance: null,
  tripAmount: null,
  zone: null,
  zoneAvailable: null,
  zoneUnAvailableMsg: null,
  agentZoneId: null,
  errors: {},
  loading: false,
  latestrides: null,
  carEstAmount: 0,
  zonePaymentList: null,
  paymentListDesc: null,
  carList: null,
  guestDetails: null,
  // REQUIREMENTS.md FR-1/2/3/6 — web rider parity slices. Plain
  // arrays (server returns canonical shape); the reducer just
  // mirrors what the booking server returns. Cleared on
  // BOOKING_CANCEL / CLEAR_BOOKING with the rest of per-ride state.
  extras: [] as any[],
  amendments: [] as any[],
  advances: [] as any[],
  // FR-3 — id of the re-booked ride after a closeAndRebook. Lives
  // on the booking row as `previous_booking_id`; we mirror it here
  // so BreakdownBanner can deep-link without extra plumbing.
  rebookedBookingId: null as number | null,
  // Track whether the rider has just hit the `arrived` state so the
  // ArrivedBanner shows even if the underlying status moves on (e.g.
  // active→arrived→started in quick succession).
  arrivedAt: null as string | null,
  // FR-1/2/6 — monotonic counter bumped on EVERY bookingRider socket
  // update (BOOKING_DATA_UPDATE). The booking server folds amendment /
  // extra / advance events into the bookingRider payload (carrying an
  // `event_type`), but those decisions don't change status/tripStart/
  // arrivedAt — so the old `bookingDataLastSeen` tick never advanced and
  // the rider's panels (AmendmentBanner/ExtrasPanel/AdvancePanel) never
  // re-fetched. This counter advances on any such message so the panels
  // refresh live. `lastEventType` lets the reducer apply event-specific
  // side-effects (e.g. new drop on amendment.accepted).
  eventSeq: 0,
  lastEventType: null as string | null,
  // Payment method change → real-time driver update (parity with mobile).
  // paymentConfirmation: the method the driver screen should reflect, as
  // `{ id: 'CASH' | 'CARD' | ... }`. Set from the rider's own selection AND
  // from the socket relay. paymentConfirmationSend: the rider→driver broadcast
  // payload `{ gateway, id: driverId }` the Socket layer emits.
  paymentConfirmation: null as any,
  paymentConfirmationSend: null as any,
  // FR-6 — cumulative advance already paid by the rider, mirrored from the
  // booking row's `advance_paid_amount`. Deducted from the final bill so the
  // rider pays (trip_amount − advance_paid_amount). Parity with mobile.
  advancePaidAmount: 0,
  // REQUIREMENTS.md FR-15 — last-fetched canned-reply library. Chat
  // component refetches on (role, zone, context) change, so this
  // slot just mirrors whatever the most recent fetch returned.
  cannedReplies: [] as any[],
  // FR-10 — live driver position pushed by soc as the driver's phone
  // pings location. Cleared on booking cancel / clear so the marker
  // doesn't linger on the next ride.
  driverLiveLocation: null as null | {
    lat: number;
    lng: number;
    custId?: string;
    bookingStatus?: any;
    receivedAt?: number;
  },
  // PHASE 0 (#12) — progressive route trail behind the driver marker, fed by
  // soc's `saveCurrentBookingTrack`. Mobile had this; web did not. Capped so a
  // long trip can't grow the array without bound.
  driverTrail: [] as Array<{ lat: number; lng: number }>,
  // PHASE 0 (#12) — live ETA from soc's `etaUpdate`. Web previously showed a
  // frozen value for the whole ride.
  driverEta: null as null | { minutes?: number; distance?: any; receivedAt?: number },
  // FR-13 #8 — last applied tip (mirror of c_bookings.tip_amount).
  // Used by CompletedView to render "Tipped £X" once the rider taps
  // a chip.
  tipAmount: null as number | null,
  // FR-13 #10 — most recent share link issued for the active ride.
  // { url, token, expires_in }.
  shareLink: null as null | { url: string; token: string; expires_in: number },
  // FR-13 #1 — recent unique rides for the home re-book carousel.
  recentRides: [] as any[],
    trunkLuggage: 0,
  handLuggage: 0,
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case PICKUP:
      return { ...state, pickup: action.payload };
    case ROUTES_INFO:
      return { ...state, routesInfo: action.payload };
    case DROP:
      let tempDrop: any = [...state.drop];
      if (tempDrop) {
        if (state.selectedLocation?.stop !== undefined) {
          tempDrop[state.selectedLocation.stop] = action.payload;
        } else {
          tempDrop[0] = action.payload;
        }
      }
      return { ...state, drop: tempDrop };
    case DROPS:
      return { ...state, drops: action.payload };
    case SELECTED_LOCATION:
      return { ...state, selectedLocation: action.payload };
    case BOOKING_DISTANCE:
      return { ...state, distance: action.payload };
    case BOOKING_DURATION:
      return { ...state, duration: action.payload };
    case CAR_TYPE:
      return { ...state, carType: action.payload };
    case CAR_EST_AMOUNT:
      return { ...state, carEstAmount: action.payload };
    case BOOKING_SCREEN_SIZE:
      return { ...state, bookingScreenSize: action.payload };
    case BOOKING_DRIVER:
      return { ...state, driver: action.payload };
    case CHAT_MESSAGE_SEND:
      return { ...state, chatMessageSend: action.payload };
    case CHAT_OPEN_STATUS:
      return { ...state, isChatOpen: action.payload };
    case CHAT_MESSAGE_UPDATE:
      // Handle both single message and array of messages
      const newMessages: any[] = Array.isArray(action.payload) ? action.payload : [action.payload];

      // If we're receiving a full chat array (from fetch), replace the chat
      // Otherwise, append new messages while avoiding duplicates
      if (Array.isArray(action.payload) && action.payload.length > 0 && action.payload[0].booking_id) {
        // This is a full chat fetch, replace the entire chat
        return {
          ...state,
          chat: action.payload
        };
      }

      // For single messages, append without duplicates
      const existingChat: any[] = state.chat || [];
      const updatedChat: any[] = [...existingChat];

      newMessages.forEach((newMsg: any) => {
        // Check if message already exists based on id, msg, and time
        const timeKey = newMsg.time ? Math.floor(newMsg.time / 1000) : 0;
        const exists = updatedChat.some((msg: any) => {
          const msgTimeKey = msg.time ? Math.floor(msg.time / 1000) : 0;
          return msg.id === newMsg.id && msg.msg === newMsg.msg && msgTimeKey === timeKey;
        });

        if (!exists) {
          updatedChat.push(newMsg);
        }
      });

      return {
        ...state,
        chat: updatedChat
      };

    case ZONE_PAY_GATEWAYS.PENDING:
      return { ...state, loading: true, errors: null };

    case ZONE_PAY_GATEWAYS.SUCCESS:
      return { ...state, loading: false, zonePaymentList: action.payload.data };

    case ZONE_PAY_GATEWAYS.FAILURE:
      return { ...state, loading: false, errors: action.payload };

    case REFRESH_BOOKING.PENDING:
      return { ...state };
    case REFRESH_BOOKING.SUCCESS:
      return { ...state };
    case REFRESH_BOOKING.FAILURE:
      return { ...state, errors: action.payload };

    case PAYMENT_LIST_DESC.PENDING:
      return { ...state };
    case PAYMENT_LIST_DESC.SUCCESS:
      return { ...state, paymentListDesc: action.payload.data };
    case PAYMENT_LIST_DESC.FAILURE:
      return { ...state, errors: action.payload };

    case CAR_LIST.PENDING:
      return { ...state };
    case CAR_LIST.SUCCESS:
      return { ...state, carList: action.payload.data.data };
    case CAR_LIST.FAILURE:
      return { ...state, errors: action.payload };

    case GUEST_SAVE.PENDING:
      return { ...state };
    case GUEST_SAVE.SUCCESS:
      console.log('action.payload.data', action.payload.data);
      return { ...state, guestDetails: action.payload.data };
    case GUEST_SAVE.FAILURE:
      return { ...state, errors: action.payload };

    // REQUIREMENTS.md FR-2 — extras list + decide. The decide
    // SUCCESS doesn't refresh the array on its own; the rider UI
    // dispatches a follow-up fetchExtraCharges so we don't have to
    // pattern-match the server's response shape here.
    case FETCH_EXTRA_CHARGES.PENDING:
      return { ...state };
    case FETCH_EXTRA_CHARGES.SUCCESS:
      return { ...state, extras: Array.isArray(action.payload?.data) ? action.payload.data : [] };
    case FETCH_EXTRA_CHARGES.FAILURE:
      return { ...state, extras: [], errors: action.payload };
    case DECIDE_EXTRA_CHARGE.PENDING:
      return { ...state };
    case DECIDE_EXTRA_CHARGE.SUCCESS:
      return { ...state };
    case DECIDE_EXTRA_CHARGE.FAILURE:
      return { ...state, errors: action.payload };

    case FETCH_AMENDMENTS.PENDING:
      return { ...state };
    case FETCH_AMENDMENTS.SUCCESS:
      return { ...state, amendments: Array.isArray(action.payload?.data) ? action.payload.data : [] };
    case FETCH_AMENDMENTS.FAILURE:
      return { ...state, amendments: [], errors: action.payload };
    case REQUEST_AMENDMENT.PENDING:
      return { ...state };
    case REQUEST_AMENDMENT.SUCCESS:
      return { ...state };
    case REQUEST_AMENDMENT.FAILURE:
      return { ...state, errors: action.payload };

    case FETCH_ADVANCES.PENDING:
      return { ...state };
    case FETCH_ADVANCES.SUCCESS:
      return { ...state, advances: Array.isArray(action.payload?.data) ? action.payload.data : [] };
    case FETCH_ADVANCES.FAILURE:
      return { ...state, advances: [], errors: action.payload };
    case DECIDE_ADVANCE.PENDING:
      return { ...state };
    case DECIDE_ADVANCE.SUCCESS:
      return { ...state };
    case DECIDE_ADVANCE.FAILURE:
      return { ...state, errors: action.payload };

    case SET_BREAKDOWN_LINK:
      return { ...state, rebookedBookingId: action.payload || null };

    case FETCH_CANNED_REPLIES.PENDING:
      return { ...state };
    case FETCH_CANNED_REPLIES.SUCCESS:
      return {
        ...state,
        cannedReplies: Array.isArray(action.payload?.data) ? action.payload.data : [],
      };
    case FETCH_CANNED_REPLIES.FAILURE:
      return { ...state, cannedReplies: [] };

    case APPLY_TIP.PENDING:
      return { ...state };
    case APPLY_TIP.SUCCESS: {
      const tip = action.payload?.data?.tip_amount;
      return { ...state, tipAmount: Number.isFinite(Number(tip)) ? Number(tip) : state.tipAmount };
    }
    case APPLY_TIP.FAILURE:
      return { ...state, errors: action.payload };

    case ISSUE_SHARE_LINK.PENDING:
      return { ...state };
    case ISSUE_SHARE_LINK.SUCCESS: {
      const d = action.payload?.data || null;
      return { ...state, shareLink: d };
    }
    case ISSUE_SHARE_LINK.FAILURE:
      return { ...state, errors: action.payload };

    case FETCH_RECENT_RIDES.PENDING:
      return { ...state };
    case FETCH_RECENT_RIDES.SUCCESS:
      return {
        ...state,
        recentRides: Array.isArray(action.payload?.data) ? action.payload.data : [],
      };
    case FETCH_RECENT_RIDES.FAILURE:
      return { ...state, recentRides: [] };

    case SET_DRIVER_LIVE_LOCATION: {
      // PHASE 1-C: Accept the new object shape { lat, lon } emitted by the server
      // (Phase 1-A), while keeping a legacy fallback for the old [lon, lat] array
      // so that any in-flight messages from an old server version don't break the map.
      //
      // New soc payload shape:
      //   { custId, type:'driver', location:{ lat, lon }, bookingStatus, zone_id }
      // Legacy soc payload shape (pre Phase 1-A):
      //   { custId, type:'driver', location:[lon, lat], bookingStatus, bookingList, zone_id }
      const p = action.payload || {};
      const loc = p.location as any;
      if (!loc) return state;

      let lat: number;
      let lng: number;

      if (Array.isArray(loc)) {
        // Legacy: [lon, lat]
        if (loc.length < 2) return state;
        lng = Number(loc[0]);
        lat = Number(loc[1]);
      } else {
        // Object shape. PHASE 4 standardises on `lng` across all four surfaces;
        // `lon` is still accepted because the API emits both during the
        // migration and older payloads may be in flight.
        lat = Number(loc.lat);
        lng = Number(loc.lng ?? loc.lon);
      }

      // Bail on malformed coordinates so the marker doesn't snap to (0, 0)
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return state;

      return {
        ...state,
        driverLiveLocation: {
          lat,
          lng,
          custId: p.custId,
          bookingStatus: p.bookingStatus,
          receivedAt: Date.now(),
        },
      };
    }

    case SET_DRIVER_TRAIL: {
      // Accept { lat, lon } / { lat, lng } / [lon, lat]; ignore anything else
      // rather than pushing a NaN point onto the polyline.
      const raw: any = (action.payload as any)?.location ?? action.payload;
      if (!raw) return state;
      const lat = Number(Array.isArray(raw) ? raw[1] : raw.lat);
      const lng = Number(Array.isArray(raw) ? raw[0] : (raw.lng ?? raw.lon));
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return state;

      const last = state.driverTrail[state.driverTrail.length - 1];
      if (last && last.lat === lat && last.lng === lng) return state; // dedupe

      const MAX_TRAIL_POINTS = 500;
      const next = [...state.driverTrail, { lat, lng }];
      return {
        ...state,
        driverTrail: next.length > MAX_TRAIL_POINTS ? next.slice(-MAX_TRAIL_POINTS) : next,
      };
    }

    case SET_DRIVER_ETA: {
      const p: any = action.payload;
      if (!p) return state;
      return {
        ...state,
        driverEta: {
          minutes: p.minutes ?? p.eta ?? p.duration,
          distance: p.distance,
          receivedAt: Date.now(),
        },
      };
    }

    // Payment method change → driver real-time update (parity with mobile).
    // Normalize bare gateway strings (e.g. 'cash') to the { id } object shape
    // the driver payment screen reads, mirroring mobile's Socket handler.
    case SET_PAYMENT_CONFIRMATION: {
      const a: any = action.payload;
      const normalized =
        typeof a === 'string'
          ? { id: a.toUpperCase(), payment_title: a }
          : a;
      return { ...state, paymentConfirmation: normalized };
    }
    case SET_PAYMENT_CONFIRMATION_SEND:
      return { ...state, paymentConfirmationSend: action.payload };

    case CURRENT_RIDE_CHECK.PENDING:
      return { ...state, loading: true };
    case CURRENT_RIDE_CHECK.SUCCESS:
      let totalRides = [];
      if (action.payload.data.length > 0) {
        totalRides = action.payload.data.map((item: any) => {
          return {
            ...item,
            pickup: item.pickup ? JSON.parse(item.pickup) : null,
            drop: item.drop ? JSON.parse(item.drop) : null,
            drops: item.drops ? JSON.parse(item.drops) : null,
            bookingTime: item.booking_time,
            bookingStatus: item.status,
          };
        });
      }
      return {
        ...state,
        loading: false,
        currentRidesList: totalRides,
      };
    case CURRENT_RIDE_CHECK.FAILURE:
      return {
        ...state,
        loading: false,
        currentRidesList: null,
        errors: action.payload,
      };
    case NEW_CURRENT_RIDE:
      let currentRides: any = [];
      if (state.currentRidesList) {
        currentRides = [...state.currentRidesList];
      }
      // Normalize pickup/drop/drops to objects the same way CURRENT_RIDE_CHECK
      // does — the socket payload may deliver them as JSON strings, and the
      // consumers (agent dashboard) read `.add` off parsed objects.
      const safeJson = (v: any) => {
        if (!v || typeof v !== 'string') return v ?? null;
        try { return JSON.parse(v); } catch (_) { return v; }
      };
      const newRide = {
        ...action.payload,
        pickup: safeJson(action.payload?.pickup),
        drop: safeJson(action.payload?.drop),
        drops: safeJson(action.payload?.drops),
      };
      currentRides.unshift(newRide);
      return { ...state, currentRidesList: currentRides };

    case BOOKING_DATA_UPDATE:
      let currentData = { ...state };
      let temp = action.payload;
      if (String(temp.booking_id) === String(currentData.bookingId)) {
        // FR-1/2/6 — advance the event tick on every matching update so the
        // amendment / extras / advance panels re-fetch even when the booking
        // status itself didn't change (e.g. an amendment was just accepted).
        currentData.eventSeq = (Number(currentData.eventSeq) || 0) + 1;
        currentData.lastEventType = temp.event_type || null;

        // FR-1 — when the driver ACCEPTS a drop change, the booking server
        // sends the recomputed pickup/drop in this same payload. Apply them
        // immediately so the rider's route/map updates without a follow-up GET.
        if (temp.event_type === 'amendment.accepted') {
          if (Array.isArray(temp.drop) && temp.drop.length > 0) {
            currentData.drop = temp.drop;
            currentData.drops = temp.drop;
          }
          if (temp.pickup && temp.pickup.lat != null && temp.pickup.lon != null) {
            currentData.pickup = temp.pickup;
          }
        }

        currentData.driver = {
          id: temp.driver_id,
          name: temp.driver_name,
          details: temp.driver_details,
        };
        currentData.bookingStatus = temp.status;
        currentData.rider = {
          id: temp.rider_id,
          name: temp.rider_name,
          details: temp.rider_details,
        };
        currentData.otp = temp.otp;
        currentData.bookingId = temp.booking_id;
        currentData.tripStartTime = temp.trip_started_time;
        currentData.tripTime = temp.trip_time;
        currentData.tripDistance = temp.trip_distance;
        currentData.tripAmount = temp.trip_amount;
        currentData.bookingSchedule = temp.booking_schedule;
        currentData.bookingTime = temp.booking_time;
        currentData.duration = temp.duration;
        currentData.estimatedTime = temp.estimated_time;
        currentData.estimatedDistance = temp.estimated_distance;

        // FR-13 #8 — reflect a tip applied from another session / the
        // server. Guard against null so unrelated booking events don't
        // wipe a tip already shown locally (from this session's POST).
        if (temp.tip_amount != null && Number.isFinite(Number(temp.tip_amount))) {
          currentData.tipAmount = Number(temp.tip_amount);
        }

        // FR-6 — mirror the cumulative advance paid so the final bill deducts
        // it. The server sends `advance_paid_amount` on every booking event.
        if (temp.advance_paid_amount != null && Number.isFinite(Number(temp.advance_paid_amount))) {
          currentData.advancePaidAmount = Number(temp.advance_paid_amount) || 0;
        }

        // FR-4 — sticky arrived stamp (cleared on CLEAR_BOOKING).
        if (temp.status === 'arrived' && !currentData.arrivedAt) {
          currentData.arrivedAt = temp.arrived_at || new Date().toISOString();
        }
        // FR-3 — when the booking server fans out a closeAndRebook,
        // the closed-row payload carries `previous_booking_id`
        // pointing at... wait — the *new* row carries it. The
        // closed row doesn't. Soc fans out *both* events so the
        // rider receives the closed-row event first (status flips
        // to closed_breakdown / closed_driver_cancel) and the new-
        // row event second (status flips to pending|active on a
        // fresh booking_id). We capture the rebookedBookingId off
        // the matching closeAndRebook payload — which the helper
        // adds as `rebooked_booking_id` on the closed-row event.
        if (temp.rebooked_booking_id) {
          currentData.rebookedBookingId = temp.rebooked_booking_id;
        }

        // Immutable currentRidesList update — shallow copy first so we don't
        // mutate the existing Redux state array (the spread above only copies
        // the top-level state object, not nested arrays).
        const terminalStatuses = new Set(["completed", "cancelled", "deleted", "inactive"]);
        if (Array.isArray(currentData.currentRidesList)) {
          if (terminalStatuses.has(temp.status)) {
            // Remove the ride from the list entirely on terminal status.
            // Note: previously `if (deletedItem)` was falsy when the ride was
            // at index 0 — the first item was never removed. Fixed by filtering
            // instead of using an index.
            currentData.currentRidesList = currentData.currentRidesList.filter(
              (item: any) => item.id !== currentData.bookingId
            );
          } else {
            // Update status in the list without mutating existing items.
            currentData.currentRidesList = currentData.currentRidesList.map(
              (item: any) =>
                item.id === currentData.bookingId
                  ? { ...item, status: temp.status, bookingStatus: temp.status }
                  : item
            );
          }
        }
      }
      return { ...currentData };
    case SELECT_RIDE:
      let rideData = state.currentRidesList[0];
      let chat = null;
      if (rideData?.chat_queue) {
        if (typeof rideData.chat_queue === "string") {
          chat = JSON.parse(rideData.chat_queue);
        }
      }
      let rider = null;
      let driver = null;

      if (rideData.rider_id && rideData.rider_id !== "") {
        let details = {};
        if (typeof rideData.rider_details === "string") {
          details = JSON.parse(rideData.rider_details);
        }
        rider = {
          id: rideData.rider_id,
          name: rideData.rider_name,
          details: details,
        };
      }

      if (rideData.driver_id && rideData.driver_id !== "") {
        let details = {};
        if (typeof rideData.driver_details === "string") {
          details = JSON.parse(rideData.driver_details);
        }
        driver = {
          id: rideData.driver_id,
          name: rideData.driver_name,
          details: details,
        };
      }
      let currentRidesList: any = null;

      if (state.currentRidesList) {
        const terminalStatuses = new Set(["completed", "cancelled", "deleted", "inactive"]);
        if (terminalStatuses.has(rideData.status)) {
          const filtered = state.currentRidesList.filter(
            (item: any) => item.id !== state.bookingId
          );
          currentRidesList = filtered.length > 0 ? filtered : null;
        } else {
          currentRidesList = state.currentRidesList.map((item: any) =>
            item.id === state.bookingId
              ? { ...item, status: rideData.status, bookingStatus: rideData.status }
              : item
          );
        }
      }

      return {
        ...state,
        currentRidesList: currentRidesList,
        pickup: {
          location: {
            latitude: rideData.pickup.lat,
            longitude: rideData.pickup.lon,
          },
          address: rideData.pickup.add,
        },
        drop: rideData.drop.map((item: any) => ({
          location: {
            latitude: item.lat,
            longitude: item.lon,
          },
          address: item.add,
        })),
        drops: rideData.drop.map((item: any) => ({
          location: {
            latitude: item.lat,
            longitude: item.lon,
          },
          address: item.add,
        })),
        zone: rideData.pickup.zone,
        carType: rideData.car_type_id,
        distance: rideData.estimated_distance,
        duration: rideData.estimated_time,
        estimated_amount: rideData.estimated_amount,
        bookingId: rideData.id,
        otp: rideData.otp,
        driver: driver,
        rider: rider,
        chat: chat,
        tripStartTime: rideData.trip_started_time,
        tripTime: rideData.trip_time,
        tripDistance: rideData.trip_distance,
        tripAmount: rideData.trip_amount,
        bookingSchedule: rideData.booking_schedule,
        bookingTime: rideData.booking_time,
        bookingStatus: rideData.status,
        // Special requirements (wheelchair / pets / airport flight) of the loaded
        // ride, from the booking_additional_data blob — displayed on the live
        // driver/rider view. Kept as the raw value; consumers parse it.
        bookingAdditional: rideData.booking_additional_data ?? null,
      };

    case CHECK_ZONE.PENDING:
      return { ...state, zone: null, loading: true };
    case CHECK_ZONE.SUCCESS:
      return {
        ...state,
        loading: false,
        zone: action.payload.data,
        zoneAvailable: action.payload.zone_available,
        zoneUnAvailableMsg: action.payload.msg,
        agentZoneId: action.payload.agent_zone_id || null,
      };
    case CHECK_ZONE.FAILURE:
      return { ...state, zone: null, loading: false, errors: action.payload };

    case AVAILABLE_CARS.PENDING:
      return { ...state, loading: true };
    case AVAILABLE_CARS.SUCCESS:
      return { ...state, availableCars: action.payload.data, loading: false };
    case AVAILABLE_CARS.FAILURE:
      return {
        ...state,
        errors: action.payload,
        loading: false,
      };


    case BOOKING_AMOUNTS.PENDING:
      return { ...state };
    case BOOKING_AMOUNTS.SUCCESS:
      return { ...state, bookingAmounts: action.payload.data };
    case BOOKING_AMOUNTS.FAILURE:
      return { ...state, errors: action.payload };

    case ESTIMATED_PRICES.PENDING:
      return { ...state, estimatedPrices: null, loading: true };
    case ESTIMATED_PRICES.SUCCESS:
      return { ...state, estimatedPrices: action.payload.data, loading: false };
    case ESTIMATED_PRICES.FAILURE:
      return {
        ...state,
        estimatedPrices: null,
        errors: action.payload,
        loading: false,
      };

    case BOOKING_SAVE.PENDING:
      return { ...state, bookingId: null, loading: true };
    case BOOKING_SAVE.SUCCESS: {
      const saveData = action.payload.data;
      return {
        ...state,
        bookingId: saveData.booking_id || null,
        bookingSchedule: saveData.booking_schedule || (saveData.schedule_id ? 'schedule' : null),
        bookingTime: saveData.booking_time,
        bookingStatus: saveData.booking_id ? "pending" : null,
        scheduleId: saveData.schedule_id || null,
        scheduleUniCode: saveData.schedule_uni_code || null,
        loading: false,
      };
    }
    case BOOKING_SAVE.FAILURE:
      return {
        ...state,
        bookingId: null,
        errors: action.payload,
        loading: false,
      };

    case START_TRIP.PENDING:
      return { ...state, loading: true };
    case START_TRIP.SUCCESS:
      return {
        ...state,
        bookingStatus: action.payload.status,
        tripStartTime: action.payload.trip_started_time,
        loading: false,
      };
    case START_TRIP.FAILURE:
      return { ...state, loading: false, errors: action.payload };

    case STOP_TRIP.PENDING:
      return { ...state, loading: true };
    case STOP_TRIP.SUCCESS:
      return {
        ...state,
        bookingStatus: action.payload.status,
        tripTime: action.payload.trip_time,
        tripDistance: action.payload.trip_distance,
        tripAmount: action.payload.trip_amount,
        loading: false,
      };
    case STOP_TRIP.FAILURE:
      return { ...state, loading: false, errors: action.payload };

    case BOOKING_PAYMENT_TYPE.PENDING:
      return { ...state, loading: true };
    case BOOKING_PAYMENT_TYPE.SUCCESS:
      return { ...state, loading: false };
    case BOOKING_PAYMENT_TYPE.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case PAYMENT_CONFIRM_TRIP.PENDING:
      return { ...state, loading: true };
    case PAYMENT_CONFIRM_TRIP.SUCCESS:
      return {
        ...state,
        bookingStatus: action.payload.status,
        payment: action.payload.payment,
        loading: false,
      };
    case PAYMENT_CONFIRM_TRIP.FAILURE:
      return { ...state, loading: false, errors: action.payload };

    case CANCEL_REASONS.PENDING:
      return { ...state, cancelReasons: null, loading: true };
    case CANCEL_REASONS.SUCCESS:
      return { ...state, cancelReasons: action.payload.data, loading: false };
    case CANCEL_REASONS.FAILURE:
      return {
        ...state,
        cancelReasons: null,
        errors: action.payload,
        loading: false,
      };

    case LATEST_RIDES.PENDING:
      return { ...state, latestrides: null, loading: true };
    case LATEST_RIDES.SUCCESS:
      return { ...state, latestrides: action.payload.data, loading: false };
    case LATEST_RIDES.FAILURE:
      return {
        ...state,
        latestrides: [],
        errors: action.payload,
        loading: false,
      };

    case BOOKING_CANCEL.PENDING:
      return { ...state, bookingId: null, loading: true };
    case BOOKING_CANCEL.SUCCESS:
      return {
        ...state,
        loading: false,
        bookingId: null,
        pickup: null,
        routesInfo: null,
        drop: [],
        drops: [],
        distance: null,
        duration: null,
        carEstAmount: 0,
        carType: null,
        driver: null,
        rider: null,
        otp: null,
        chat: null,
        chatMessageSend: null,
        bookingSchedule: null,
        bookingTime: null,
        bookingStatus: null,
        scheduleId: null,
        scheduleUniCode: null,
        selectedLocation: null as any,
        estimatedPrices: null,
        estimatedTime: null,
        estimatedDistance: null,
        availableCars: null,
        cancelReasons: null,
        tripStartTime: null,
        tripTime: null,
        tripDistance: null,
        tripAmount: null,
        zone: null,
        zoneAvailable: null,
        zoneUnAvailableMsg: null,
        extras: [],
        amendments: [],
        advances: [],
        rebookedBookingId: null,
        arrivedAt: null,
        driverLiveLocation: null,
        driverTrail: [],
        driverEta: null,
        tipAmount: null,
        shareLink: null,
        eventSeq: 0,
        lastEventType: null,
        paymentConfirmation: null,
        paymentConfirmationSend: null,
        advancePaidAmount: 0,
      };
    case BOOKING_CANCEL.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case RATING_SAVE.PENDING:
      return { ...state };
    case RATING_SAVE.SUCCESS:
      return { ...state };
    case RATING_SAVE.FAILURE:
      return { ...state, errors: action.payload };

    case AIRPORT_SERVICE:
      return { ...state, airportService: action.payload };
    case FLIGHT_NUMBER:
      return { ...state, flightNumber: action.payload };
    case FLIGHT_DATETIME:
      return { ...state, flightDateTime: action.payload };
    case TERMINAL:
      return { ...state, selectedTerminal: action.payload };
    case TRUNK_LUGGAGE:
      return { ...state, trunkLuggage: action.payload };
    case HAND_LUGGAGE:
      return { ...state, handLuggage: action.payload };

    case CLEAR_BOOKING:
      return {
        ...state,
        loading: false,
        bookingId: null,
        pickup: null,
        drop: [],
        drops: [],
        distance: null,
        duration: null,
        carType: null,
        driver: null,
        rider: null,
        otp: null,
        chat: null,
        chatMessageSend: null,
        bookingSchedule: null,
        bookingTime: null,
        bookingStatus: null,
        scheduleId: null,
        scheduleUniCode: null,
        selectedLocation: null as any,
        estimatedPrices: null,
        estimatedTime: null,
        estimatedDistance: null,
        availableCars: null,
        cancelReasons: null,
        tripStartTime: null,
        tripTime: null,
        tripDistance: null,
        tripAmount: null,
        zone: null,
        zoneAvailable: null,
        zoneUnAvailableMsg: null,
        extras: [],
        amendments: [],
        advances: [],
        rebookedBookingId: null,
        arrivedAt: null,
        driverLiveLocation: null,
        driverTrail: [],
        driverEta: null,
        tipAmount: null,
        shareLink: null,
        eventSeq: 0,
        lastEventType: null,
        paymentConfirmation: null,
        paymentConfirmationSend: null,
        advancePaidAmount: 0,
      };
    default:
      return state;
  }
};

export default reducer;
